// extracted by mini-css-extract-plugin
export default {"contentMain":"ZoomModal_contentMain__A-73t"};